import { utils } from '../../utils';
export function AttributeBase(Base) {
    class AttributeBaseClass extends Base {
        constructor() {
            super(...arguments);
            this.equals = utils.equals(AttributeBaseClass, this, (other) => this.usage === other.usage && this.value.equals(other.value));
            this.toKeyString = () => `${AttributeBaseClass.name}:${this.usage}:${this.value.toString('hex')}`;
        }
        static deserializeAttributeWireBase({ reader }) {
            const usage = reader.readUInt8();
            return { usage };
        }
        serializeJSON(_context) {
            throw new Error('Not Implemented');
        }
    }
    return AttributeBaseClass;
}

//# sourceMappingURL=AttributeBase.js.map
